<template>
  <div>
    <back-btn/>
    <div class="d-flex justify-space-between align-center mb-3">
      <v-card-title class="pa-0">Изменить филиал</v-card-title>
      <v-btn color="primary" @click="changePasswordDialog = true">Изменить пароль</v-btn>
    </div>
    <v-card>
      <v-card-text>
        <validation-observer v-slot="{handleSubmit}" ref="formObs">
          <form @submit.prevent="handleSubmit(save)">
            <v-card-title class="px-0">Филиал инфо</v-card-title>
            <v-row class="form-dialog-modal">
              <v-col sm="6" cols="12" lg="3">
                <custom-autocomplete
                    clearable
                    label="Родитель"
                    :items="mkos"
                    v-model="formData.parent_id"
                ></custom-autocomplete>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required"
                    label="Бренд"
                    vid="name"
                    v-model="formData.name"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required"
                    label="Название фирмы"
                    vid="company_name"
                    v-model="formData.company_name"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Номер телефона"
                    prefix="998"
                    pattern="##-###-##-##"
                    rules="required|phone"
                    vid="phone"
                    v-model="formData.phone"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required|email"
                    label="Email"
                    vid="email"
                    v-model="formData.email"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required"
                    label="Адрес"
                    v-model="formData.address"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Телеграм"
                    v-model="formData.telegram_channel"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Допольнительная информация"
                    v-model="formData.info"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Директор"
                    rules="required"
                    vid="director"
                    v-model="formData.director"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <validation-provider name="Лого" v-slot="{errors}" v-if="typeof formData.logo !== 'string'">
                  <v-file-input
                      label="Лого"
                      v-model="formData.logo"
                      :error-messages="errors[0]"
                  ></v-file-input>
                </validation-provider>
                <v-sheet v-else style="position:relative;" width="100" height="100" class="mb-2">
                  <v-img class="circle-radius" max-width="100" height="100" :src="formData.logo_url"></v-img>
                  <!--              <v-sheet class="primary pl-2 pr-8 py-2 d-flex border-radius-5 white&#45;&#45;text align-center pos-r" v-else>-->
                  <!--                <span>{{ formData.logo }}</span>-->
                  <!--                <v-btn @click="formData.logo = null" dark icon class="v-btn&#45;&#45;absolute v-btn&#45;&#45;right">-->
                  <!--                  <v-icon small>fas fa-times</v-icon>-->
                  <!--                </v-btn>-->
                  <!--              </v-sheet>-->
                  <v-btn style="left: 35px" @click="formData.logo = null" color="error" icon absolute bottom small>
                    <v-icon x-small>fas fa-times</v-icon>
                  </v-btn>
                </v-sheet>
              </v-col>
            </v-row>

            <v-card-title class="px-0">Банковские данные</v-card-title>
            <v-row class="form-dialog-modal">
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Банк"
                    rules="required"
                    v-model="formData.bank"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="ИНН"
                    rules="required"
                    v-model="formData.inn"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="МФО"
                    rules="required"
                    v-model="formData.mfo"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Расчетный счет"
                    v-model="formData.payment_account"
                ></custom-input-text>
              </v-col>
            </v-row>
            <v-btn type="submit" width="100%" color="primary" :loading="loading">Сохранить</v-btn>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
    <v-dialog v-model="changePasswordDialog" width="500">
      <v-card>
        <v-card-title class="mb-3">Изменить праоль</v-card-title>
        <v-card-text>
          <validation-observer v-slot="{handleSubmit}" ref="changePasswordFormObs">
            <form @submit.prevent="handleSubmit(changePassword)">
              <custom-input-text
                  rules="required"
                  label="Пароль"
                  v-model="credentialFormData.password"
                  type="password"/>
              <custom-input-text
                  label="Введите пароль еще раз"
                  v-model="credentialFormData.confirm_password"
                  :rules="{
                    required:true,
                    min: 6,
                    confirmed:credentialFormData.password}"
                  type="password"/>
              <v-btn width="100%" color="primary" type="submit">Сохранить</v-btn>
            </form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>


<script>
import {messages, parsePhone, phoneMask, ROLES} from "@/utils/constants"
import MoneyInput from "@/plugins/vuetify/components/MoneyInput";
import {getObjectValuesByKey, trueSetString} from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";


export default {
  components: {BackBtn, MoneyInput},
  props: ['id'],
  data() {
    return {
      changePasswordDialog: false,
      loading: false,
      credentialFormData: {
        password: null,
        confirm_password: null
      },
      formData: {
        user_id: null,
        parent_id: null,
        bank: null,
        name: null,
        company_name: null,
        email: null,
        phone: null,
        logo: null,
        inn: null,
        mfo: null,
        address: null,
        telegram_channel: null,
        info: null,
        director: null,
        payment_account: null
      },
      mkos: [],
    }
  },
  computed: {

    phoneMask,

  },
  methods: {
    async changePassword() {
      this.$showLoading()
      try {
        await this.$http.post(`admin/mko/change-password/${this.id}`, this.credentialFormData)
        this.changePasswordDialog = false
        this.$setSuccess({text: messages.onSave})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs.changePasswordFormObs})
      } finally {
        this.$clearLoading()
      }
    },

    async save() {
      const formData = new FormData()
      let data = {...this.formData}
      data.phone = parsePhone(data.phone).format('max')
      Object.entries(data).forEach(([key, value]) => {
        if (value) {
          formData.append(key, `${value}`)
        }
      })
      this.loading = true
      await this.update(formData)
      this.loading = false
    },
    async update(formData) {
      try {
        formData.append('_method', 'put')
        await this.$http.post(`admin/mko/branch-edit/${this.id}`, formData)
        this.$setSuccess({text: messages.onSave})
        await this.$router.push({name: 'mko-index'})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      }
    },
    getMkoData() {
      return this.$http.get(`admin/mko/${this.id}`)
    }
  },
  async created() {
    this.$showLoading()
    try {
      this.mkos = await this.$store.dispatch('getMkos')
      if (this.id) {
        const {data: {data: {mko}}} = await this.getMkoData()
        mko.phone = parsePhone(mko.phone).format('min')
        this.formData = getObjectValuesByKey(this.formData, mko)
      }
    } catch (e) {
      this.$setResponseError({error: e})
    } finally {
      this.$clearLoading()
    }


  }
}
</script>
